import { IconAdd, SecondaryButton } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { useFinancialAccountBankingDetailsButtonPresenter } from './useFinancialAccountBankingDetailsButtonPresenter'
import { FinancialAccountBankingDetailsModal } from '../../views/FinancialAccountBankingDetailsModal'

export interface IFinancialAccountBankingDetailsButtonPresenterProps {
  financialAccountId: number
}

export const FinancialAccountBankingDetailsButtonPresenter = ({
  financialAccountId,
}: IFinancialAccountBankingDetailsButtonPresenterProps) => {
  const intl = useProcurifyIntl()

  const {
    data: { accountDetails },
    states: { isModalOpen },
    commands: {
      openFinancialAccountBankingDetailsModal,
      closeFinancialAccountBankingDetailsModal,
    },
  } = useFinancialAccountBankingDetailsButtonPresenter({
    financialAccountId,
  })

  return (
    <>
      <SecondaryButton
        iconComponent={<IconAdd />}
        onClick={openFinancialAccountBankingDetailsModal}
      >
        {intl.formatMessage(messages.buttonText)}
      </SecondaryButton>

      <FinancialAccountBankingDetailsModal
        open={isModalOpen}
        onClose={closeFinancialAccountBankingDetailsModal}
        accountDetails={accountDetails || {}}
      />
    </>
  )
}
